import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Home from "./Pages/Home";
import Step2 from "./Pages/Step-2";
import Step3 from "./Pages/Step-3";
import Step3Manual from "./Pages/Step-3-manual";
import Step4 from "./Pages/Step-4";
import Step5 from "./Pages/Step-5";
import Help from "./Pages/Help";
import Tracking from "./Pages/Tracking";
import DisableGoogleMaps from "./Pages/DisableGoogleMaps";
import EnableGoogleMaps from "./Pages/EnableGoogleMaps";
import Quick from "./Pages/Quick";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PortalContext from "./Pages/PortalContext";
import { TranslationProvider } from "./Pages/TranslationContext";
import { useGetRequest } from "./Client/index.js";
import WebFont from "webfontloader";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/step-2",
    element: <Step2 />,
  },
  {
    path: "/step-3",
    element: <Step3 />,
  },
  {
    path: "/step-3-manual",
    element: <Step3Manual />,
  },
  {
    path: "/step-4",
    element: <Step4 />,
  },
  {
    path: "/order-success",
    element: <Step5 />,
  },
  {
    path: "/help",
    element: <Help />,
  },
  {
    path: "/tracking",
    element: <Tracking />,
  },
  {
    path: "/disable-google-maps",
    element: <DisableGoogleMaps />,
  },
  {
    path: "/enable-google-maps",
    element: <EnableGoogleMaps />,
  },
  {
    path: "/quick",
    element: <Quick />,
  },
]);

const queryClient = new QueryClient();

function Component() {
  const { status, data } = useGetRequest(
    "api/v2-label-portal-retailer.php",
    {}
  );

  const loadGoogleFont = (fontName) => {
    WebFont.load({
      google: {
        families: [fontName],
      },
    });
  };

  useEffect(() => {
    const font = data?.settings?.fonts?.google?.name;
    loadGoogleFont(font ? font : "Roboto");
    document.documentElement.style.setProperty("--user-font", font);
  }, [data]);

  // set to empty string if not available
  document.title = data?.settings?.tradingName
    ? `${data?.settings?.tradingName} | Powered by Ezi Returns`
    : "";

  if (status !== "fetched") {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (status === "fetched") {
    return (
      <QueryClientProvider client={queryClient}>
        <PortalContext.Provider
          value={{
            portal: {
              data: data,
            },
          }}
        >
          <TranslationProvider>
            <RouterProvider router={router} />
          </TranslationProvider>
        </PortalContext.Provider>
      </QueryClientProvider>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Component />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
